import React from 'react'

import { useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import { useDialogStore } from '@stores/dialog.store'

import StopSellingDialog from './StopSellingDialog'

const StopSellingButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)

  return (
    <>
      <Button
        variant="primary"
        onClick={() => openDialog('stop_selling')}
        className="text-md py-1.5 px-3 flex flex-row items-center justify-center">
        {t('action.stopSelling')}
      </Button>
      <StopSellingDialog />
    </>
  )
}

export default StopSellingButton
